import type { TTipoDocumento } from '@/features/enviar-documentos/services'

export const listaDocumentosPessoaJuridica: Array<{ value: TTipoDocumento; label: string }> = [
  { value: 'CartaoCNPJ', label: 'Cartão CNPJ' },
  { value: 'ContratoSocial', label: 'Contrato Social' },
  { value: 'UltimaAlteracao', label: 'Última Alteração' },
  { value: 'CertidaoJuntaComercial', label: 'Certidão Junta Comercial' },
  { value: 'ComprovanteDeEnderecoDaEmpresa', label: 'Comprovante de Endereço da Empresa' },
  { value: 'OutroDocumento', label: 'Outro Documento' },
  { value: 'ComprovanteDePagamento', label: 'Comprovante de Pagamento' },
  { value: 'Checklist', label: 'Checklist' },
]
